import React, {FC, PropsWithChildren} from 'react';

const BreadCrumbsFc: FC<PropsWithChildren> = (props) => {
  return <ul className="breadcrumbs">{props.children}</ul>;
};

export default BreadCrumbsFc;
